import script from "./ProPrice.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProPrice.vue?vue&type=script&lang=ts&setup=true"

import "./ProPrice.vue?vue&type=style&index=0&id=d9df87ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d9df87ec"]])

export default __exports__